import React, { useState, useEffect } from 'react';
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Documentation from "./pages/Documentation";
import { BrowserRouter, Route, Routes} from 'react-router-dom';
import './app.css';

export default function App() {

  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(false), 3500);
    return () => clearTimeout(timer);
  }, []);


  return (
    <BrowserRouter>
      <div className="App">
        {showLoader && (
          <div className="loader">
            <img src="images/logo_yellow.png" alt="logo-loading" />
            <h1>Loading page</h1>
          </div>
        )}
        {!showLoader && (
          <div className="content">
            <Navbar />
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route path="/docs" element={<Documentation />} />
            </Routes>
            <Footer />
          </div>
        )}
      </div>
    </BrowserRouter>
  );
}

